import axios from "axios";
import * as actionType from "../../../constant/actionType";

const normalizeParam = (input, key) => {
  if (input === null || input === undefined) {
    return "[]";
  }

  if (typeof input === "string") {
    return input;
  }

  const values = (Array.isArray(input) ? input : [input])
    .map((item) => {
      if (item === null || item === undefined) {
        return null;
      }

      if (typeof item !== "object") {
        return item;
      }

      if (key && item[key] !== undefined && item[key] !== null) {
        return item[key];
      }

      if (item.id !== undefined && item.id !== null) {
        return item.id;
      }

      if (item.value !== undefined && item.value !== null) {
        return item.value;
      }

      return null;
    })
    .filter((value) => value !== null && value !== undefined && value !== "");

  return JSON.stringify(values);
};

export const GetClientProviderChecklistList = (apiData = {}) => async (dispatch) => {
  try {
    const params = {
      ...apiData,
      provider_org_ids: normalizeParam(apiData.provider_org_ids, "provider_org_id"),
      client_org_ids: normalizeParam(apiData.client_org_ids, "organisation_id"),
    };

    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/provider/GetClientProviderChecklistList`,
      params,
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
};
